import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appTitleToolbarDirective]',
})
export class TitleToolbarDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
